//@flow
import reducer from "./reducers";

import * as goalsOperations from "./operations";
import * as goalsSelectors from "./selectors";

export { goalsOperations, goalsSelectors };

export default reducer;
